module.exports = __webpack_public_path__ + "img/004.b2f5cdab.png";